import MediaPreview from 'components/common/MediaPreview';
import { FileViewerContext } from 'contexts/fileViewer';
import React, {
  useContext,
} from 'react';
import { MultiMediaResponse } from 'artifacts/dtos';

export default function usePreviewMediaClick() {
  const { openDialog } = useContext(FileViewerContext);
  return (media: MultiMediaResponse) => {
    openDialog({
      content: (<MediaPreview media={media} />),
      media,
    });
  };
}
